const TEMPLATE: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
const REGEXP: RegExp = /^[{]?[0-9a-fA-F]{8}-(?:[0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/;

export function newGuid(): Guid {
	// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
	return TEMPLATE.replace(/[xy]/g, (c) => {
		const r = Math.random() * 16 | 0, v = c === "x" ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	}) as Guid;
}

export function guid(value: string): Guid {
	if (!value.match(REGEXP)) {
		throw new TypeError(`Value '${value}' does not represent a valid guid`);
	}

	return value as Guid;
}

export function tryParseGuid(value: string | nil): TryResult<Guid> {
	if (!value || !value.match(REGEXP)) {
		return {
			wasSuccessful: false
		};
	}

	return {
		wasSuccessful: true,
		result: value as Guid
	};
}

export function areEqual(a: Guid | nil, b: Guid | nil): boolean {
	if (typeof a === "undefined") {
		return typeof b === "undefined";
	}

	if (a === null) {
		return b === null;
	}

	if (typeof b === "undefined" || b === null) {
		return false;
	}

	return a.toUpperCase() === b.toUpperCase();
}

export type Guid = string & { __type: "Guid"; };
